import { AttributeValueWithCount } from 'src/generated/operations.ts';

const dictionary = [
    'Modulating',
    'Open/close',
    'Mixing',
    'Modulating mixing',
    'Mixing/Diverting',
    'Changeover',
    'Modulating diverting',
    'Diverting',
];

export const compareOperatingMode = (
    a: AttributeValueWithCount,
    b: AttributeValueWithCount,
) => {
    const aValue = dictionary.findIndex((item) => item === a.value);
    const bValue = dictionary.findIndex((item) => item === b.value);
    if (a.value === b.value) {
        return 0;
    }
    return aValue > bValue ? 1 : -1;
};
